import React, { useState } from "react";

export default () => {
  const [accordionStyle, setAccordionStyle] = useState({
    display: "none",
    transitionDuration: "5s",
  });
  const [accordionStyle1, setAccordionStyle1] = useState({
    display: "none",
    transitionDuration: "5s",
  });
  const [accordionStyle2, setAccordionStyle2] = useState({
    display: "none",
    transitionDuration: "5s",
  });
  const [accordionStyle3, setAccordionStyle3] = useState({
    display: "none",
    transitionDuration: "5s",
  });
  const [accordionStyle4, setAccordionStyle4] = useState({
    display: "none",
    transitionDuration: "5s",
  });
  const [accordionStyle5, setAccordionStyle5] = useState({
    display: "none",
    transitionDuration: "5s",
  });
  const [accordionStyle6, setAccordionStyle6] = useState({
    display: "none",
    transitionDuration: "5s",
  });
  const [accordionStyle7, setAccordionStyle7] = useState({
    display: "none",
    transitionDuration: "5s",
  });

  const checkStyle = (setFunction, data) => {
    if (data.display === "none") {
      setFunction({ display: "block", transitionDuration: "5s" });
      return;
    }
    setFunction({ display: "none", transitionDuration: "5s" });
  };

  return (
    <div className="team-features-main">
      <div className="accordion" id="team-FAQ">
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingOne">
            <button
              className="accordion-button collapsed"
              type="button"
              onClick={() => checkStyle(setAccordionStyle, accordionStyle)}
            >
              What is the Philosophy of the Reteam?
            </button>
          </h2>
          <div
            style={accordionStyle}
            id="collapseOne"
            className="accordion-collapse collapse"
            aria-labelledby="headingOne"
            data-bs-parent="#team-FAQ"
          >
            <div className="accordion-body">
              Improving engagement for teams based on social behavior and
              interactions between team members.
              <br />
              We encourage the team to treat everyone as equals and strive to
              level the social playing field within the team so that everyone
              has an equitable voice, is eager and willing to share new concepts
              and ideas, and takes time to learn about each other and recognize
              each other as often as we can.
              <br />
              This is the way we believe in building strong teams.
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingTwo">
            <button
              className="accordion-button collapsed"
              type="button"
              onClick={() => checkStyle(setAccordionStyle1, accordionStyle1)}
            >
              What is the role of Team profile?
            </button>
          </h2>
          <div
            id="collapseTwo"
            className="accordion-collapse collapse"
            style={accordionStyle1}
          >
            <div className="accordion-body">
              The Team Profile helps to identify the team. <br />
              We encourage the team to pick a team image to make it unique.
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingThree">
            <button
              className="accordion-button collapsed"
              type="button"
              onClick={() => checkStyle(setAccordionStyle2, accordionStyle2)}
            >
              How do I see all of the team members on my team?
            </button>
          </h2>
          <div
            id="collapseThree"
            className="accordion-collapse collapse"
            style={accordionStyle2}
          >
            <div className="accordion-body">
              Hit the (i) icon on the team's card in the team listing. <br />
              You can see a list of team members and interact with them.
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingfour">
            <button
              className="accordion-button collapsed"
              type="button"
              onClick={() => checkStyle(setAccordionStyle3, accordionStyle3)}
            >
              How do I use the Personal Profile?
            </button>
          </h2>
          <div
            id="collapsefour"
            className="accordion-collapse collapse"
            style={accordionStyle3}
          >
            <div className="accordion-body">
              Setting information about you is an important step to helping the
              team learn about its members.
              <br />
              Add information about your working hours and personally available
              hours and share some fun pictures that may give some insight into
              your values and interests.
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingFive">
            <button
              className="accordion-button collapsed"
              type="button"
              onClick={() => checkStyle(setAccordionStyle4, accordionStyle4)}
            >
              How do I use the Wall of Fame and Announcements.
            </button>
          </h2>
          <div
            id="collapseFive"
            className="accordion-collapse collapse"
            style={accordionStyle4}
          >
            <div className="accordion-body">
              Use the Wall of Fame to recognize your teammate and do it in
              video!
              <br />
              You can also share announcements or make a Vlog for the team using
              this feature as well. We prefer video so you can share information
              being as present as possible.
              <br />
              Celebrate each other with a video posted to Wall of Fame.
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingSix">
            <button
              className="accordion-button collapsed"
              type="button"
              onClick={() => checkStyle(setAccordionStyle5, accordionStyle5)}
            >
              What are ways to use the Slideshow?
            </button>
          </h2>
          <div
            id="collapseSix"
            className="accordion-collapse collapse"
            style={accordionStyle5}
          >
            <div className="accordion-body">
              Slideshow will ask the team/group to take a picture related to the
              topic you select. Once all of the images are in, ReTeam will
              stitch the images together into a slideshow that everyone can
              view.
              <br />
              Use the slideshow to share recent vacation spots, places you’ve
              visited, favorite sports teams, favorite foods… share how you
              celebrated the holiday. Be creative, this is a great way to learn
              about each other.
              <br />
              When you get the slideshow started, select the request from the
              notificiations,and take a picture that matches the subject.
              <br />
              Use the slideshow to get to know others in your group.
              <br />
              Use it to share pictures about in event or information that you
              need.
              <br />
              Have fun with this feature
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingSeven">
            <button
              className="accordion-button collapsed"
              type="button"
              onClick={() => checkStyle(setAccordionStyle6, accordionStyle6)}
            >
              How do I use the Team Video?
            </button>
          </h2>
          <div
            id="collapseSeven"
            className="accordion-collapse collapse"
            style={accordionStyle6}
          >
            <div className="accordion-body">
              Team video is intended to be used in fun and functional ways. Try
              using team video to prepare for a meeting, to ask the group for
              open feedback, to request some thoughts about what can be done
              better, or just to reflect on the past year or past effort.
              <br />
              Use it for updates and standups.
              <br />
              Create a Team Video with introductions of the team members - this
              can help with onboarding new members as well.
              <br />
              Share how you celebrate different holidays and other events - this
              is a great way to break down Cultural barriers also.
              <br />
              Though not everyone will be comfortable with video, it is
              important that people try to open up and share information face to
              face (virtually and asynchronously).
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingSeven">
            <button
              className="accordion-button collapsed"
              type="button"
              onClick={() => checkStyle(setAccordionStyle7, accordionStyle7)}
            >
              What are some ways to use Bright Ideas?
            </button>
          </h2>
          <div
            id="collapseSeven"
            className="accordion-collapse collapse"
            style={accordionStyle7}
          >
            <div className="accordion-body">
              The Bright Ideas feature is all about brainstorming. We utilize a
              method called Iterative Ideation. Except we can do this remotely
              and over time.
              <br />
              Bright Ideas is your place to share thoughts and ideas.
              <br />
              Be receptive to others ideas and contribute with positive steps to
              help develop the idea.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
